export default __webpack_public_path__ + "static/media/logoVendor.53fc4179.svg";